import './FeatureBar.sass';

import { VNode, VNodeData } from 'vue/types/umd';
import { isCssColor, getSlot, convertToUnit } from '@/utils/helpers';

import mixins from '@/utils/mixins';
import Measurable from '@/mixins/measurable';
import Loadable from '@/mixins/loadable';
export default mixins(Measurable, Loadable).extend({
  name: 'v-feature-bar',

  props: {
    flat: Boolean,
    extended: Boolean,
    extensionHeight: {
      default: 340,
      type: Number
    },

    tag: {
      type: String,
      default: 'div'
    },
    color: String,
    loading: {
      type: [Boolean, String],
      default: false
    },
    loaderHeight: {
      type: [Number, String],
      default: 4
    }
  },
  data: () => ({
    isExtended: false
  }),
  computed: {
    classes(): object {
      return {
        'feature-bar': true,
        extended: this.extended,
        'feature-bar--flat': this.flat
      };
    },
    computedHeight(): number {
      const height = this.computedContentHeight;

      if (!this.isExtended) return height;

      const extensionHeight = this.extensionHeight;

      const finalHeight =
        height + (!isNaN(extensionHeight) ? extensionHeight : 0);
      return finalHeight;
    },
    computedContentHeight(): number {
      // if (this.height) return parseInt(this.height);
      // if (this.isProminent && this.dense) return 96;
      // if (this.isProminent && this.short) return 112;
      // if (this.isProminent) return 128;
      // if (this.dense) return 48;
      // if (this.short || this.$vuetify.breakpoint.smAndDown) return 56;
      return 80;
    },
    styles(): object {
      return {
        // ...this.measurableStyles,
        height: convertToUnit(this.computedHeight)
      };
    }
  },
  methods: {
    genDetailsContent(): VNode {
      return this.$createElement(
        'div',
        {
          class: 'feature-bar-content'
        },
        [this.genFeaturePrimaryBar(), this.genFeatureHeaderInner()]
      );
    },

    genFeatureHeaderInner(): VNode {
      return this.$createElement(
        'div',
        {
          class: 'feature-header-inner'
        },
        [this.genFeatureMain()]
      );
    },
    genFeatureMain(): VNode {
      return this.$createElement(
        'div',
        {
          class: 'project'
        },
        [this.genFeatureMainTitle(), this.genFeatureDetails()]
      );
    },
    genFeatureMainTitle(): VNode {
      return this.$createElement(
        'div',
        {
          class: 'project-name'
        },
        [this.genFeaturePrimary()]
      );
    },
    genFeaturePrimary(): VNode {
      return this.$createElement(
        'div',
        {
          class: 'feature-bar-primary'
        },
        [
          this.genFeaturePrimaryBarTitle(),
          this.genFeaturePrimaryBarBadge(),
          getSlot(this, 'button')
          // || this.$createElement('v-btn', {
          // 	props: {
          // 		outlined: true,
          // 		rounded: true,
          // 		'x-small': true,
          // 	},
          // 	style: "vertical-align: middle;",
          // 	class: "text-capitalize ml-3"
          // })
        ]
      );
    },
    genFeaturePrimaryBarTitle(): VNode {
      return this.$createElement(
        'h1',
        {
          staticClass: 'feature-bar-title'
        },
        [getSlot(this, 'title')]
      );
    },
    genFeaturePrimaryBarBadge(): VNode {
      return this.$createElement(
        'div',
        {
          staticClass: 'feature-bar-title-badge'
        },
        [getSlot(this, 'badge')]
      );
    },

    genFeatureDetails(): VNode {
      return this.$createElement(
        'div',
        {
          staticClass: 'project-details'
        },
        [getSlot(this)]
      );
    },

    genFeaturePrimaryBar(): VNode {
      return this.$createElement(
        'div',
        {
          staticClass: 'feature-bar-primary-row'
        },
        [this.genFeatureTitle(), this.genFeatureOptions()]
      );
    },

    genFeatureTitle(): VNode {
      return this.$createElement(
        'div',
        {
          staticClass: 'feature-title-lockup stetch-across'
        },
        [getSlot(this, 'title-lockup')]
      );
    },

    genFeatureOptions(): VNode {
      return this.$createElement(
        'div',
        {
          staticClass: 'feature-app-selector'
        },
        [getSlot(this, 'options')]
      );
    },

    genBackgroundImage(): VNode {
      return this.$createElement(
        'div',
        {
          staticClass: 'details-image'
        },
        [getSlot(this)]
      );
    },

    genProgress(): VNode | VNode[] | null {
      // const render = Loadable.options.methods.genProgress.call(this);
      const render = this.genLoadingProgress;
      if (!render) return null;

      return this.$createElement(
        'div',
        {
          staticClass: 'feature-bar-loading',
          key: 'progress'
        },
        this.$slots.loader || [render]
      );
    },

    setBackgroundColor(
      color?: string | false,
      data: VNodeData = {}
    ): VNodeData {
      if (typeof data.style === 'string') {
        // istanbul ignore next
        console.log('style must be an object', this);
        // istanbul ignore next
        return data;
      }
      if (typeof data.class === 'string') {
        // istanbul ignore next
        console.log('class must be an object', this);
        // istanbul ignore next
        return data;
      }
      if (isCssColor(color)) {
        data.style = {
          ...(data.style as object),
          'background-color': `${color}`,
          'border-color': `${color}`
        };
      } else if (color) {
        data.class = {
          ...data.class,
          [color]: true
        };
      }

      return data;
    }
  },
  render(h): VNode {
    this.isExtended = this.extended || !!this.$scopedSlots.extension;

    const children = [this.genProgress(), this.genDetailsContent()];
    // if (this.isExtended) children.push(this.genDetailsContent());
    const data = this.setBackgroundColor(this.color, {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    });
    return h(this.tag, data, children);
  }
});

// Vue.component('v-headline', typography('headline'))
